var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 64H240V24C240 10.75 250.7 0 264 0C277.3 0 288 10.75 288 24V64H352V24C352 10.75 362.7 0 376 0C389.3 0 400 10.75 400 24V64H464V24C464 10.75 474.7 0 488 0C501.3 0 512 10.75 512 24V224H592V184C592 170.7 602.7 160 616 160C629.3 160 640 170.7 640 184V440C640 479.8 607.8 512 568 512H72C32.24 512 0 479.8 0 440V184C0 170.7 10.75 160 24 160C37.25 160 48 170.7 48 184V224H128V24C128 10.75 138.7 0 152 0C165.3 0 176 10.75 176 24V64zM176 112V224H464V112H176zM48 272V440C48 453.3 58.75 464 72 464H256V384C256 348.7 284.7 320 320 320C355.3 320 384 348.7 384 384V464H568C581.3 464 592 453.3 592 440V272H48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.e380ea01407c8db9323478096181b9d8.svg";
export { ForwardRef as ReactComponent };